export const FirstLetterCapitalize = (data: string): string => {
  if (!data) return "";
  return data.split(" ").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ");
};